import React from "react";

export const LazyUserCircleSelect = React.lazy(() =>
    import(
        /* webpackChunkName: "UserCircleSelect" */ "./UserCircleSelect"
    ).then(module => ({ default: module.UserCircleSelect }))
);
